import { render } from "./LatestNews.vue?vue&type=template&id=0818fec2&scoped=true"
import script from "./LatestNews.vue?vue&type=script&lang=js"
export * from "./LatestNews.vue?vue&type=script&lang=js"

import "./LatestNews.vue?vue&type=style&index=0&id=0818fec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0818fec2"]])

export default __exports__